import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const BranchManagementIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.11111 2.5H15.8889V7.5H8.11111V2.5ZM2 17.5H9.77778V22.5H2V17.5ZM14.2222 17.5H22V22.5H14.2222V17.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V12.2353M6 17V12.2353H18V17"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
